import { render, staticRenderFns } from "./AccessibilitePage.vue?vue&type=template&id=2867d260&"
import script from "./AccessibilitePage.vue?vue&type=script&lang=js&"
export * from "./AccessibilitePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2867d260')) {
      api.createRecord('2867d260', component.options)
    } else {
      api.reload('2867d260', component.options)
    }
    module.hot.accept("./AccessibilitePage.vue?vue&type=template&id=2867d260&", function () {
      api.rerender('2867d260', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accessibilite/AccessibilitePage.vue"
export default component.exports